export enum MapKeyOption {
  VALUE = 'value',
  NAME = 'name',
}
